import React from 'react'
import MetaTags from '../../seo/MetaTags'
import useFirstAddressWithTownSeoPostcode from '../../seo/useFirstAddressWithTownSeoPostcode'

export const getMeta = (town, postcode) => {
  return {
    title: `Info trafic ${town} (${postcode}) : la circulation en temps réel - Mappy`,
    description: `Des bouchons ? Le trafic est-il fluide ? Avec Mappy, affichez l'info-trafic en direct sur la carte de ${town} (${postcode})`
  }
}

export const TrafficCityMetaManager = () => {
  const { town, postcode } = useFirstAddressWithTownSeoPostcode()
  return <MetaTags {...getMeta(town, postcode)} />
}

export default TrafficCityMetaManager
